import { Outlet } from "react-router";

import Header from "../../../component/layout/header";
import useNav from "../../../script/tabingNavArray";


const BillingCustomerLayout = () => {
    const navList = useNav();
    let { billingCustomerBottomNav, topConfigNav } = navList;
    return (
        <div className="webBody">
            <Header bottomTabs={billingCustomerBottomNav} topTabs={topConfigNav} />
            <Outlet />
        </div>
    );
}

export default BillingCustomerLayout;